import {
  COMPANY_LOCATION,
  COMPANY_NAME,
  COMPANY_REGION,
  COMPANY_SHORT,
  HERO_IMAGE_URL,
  PROFILE_FACTS,
} from '../constants';

function HeroSection() {
  return (
    <section className="relative overflow-hidden border-b border-line bg-paper">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 py-16 lg:grid-cols-[0.95fr_1.05fr] lg:items-center lg:py-24">
        <div>
          <span className="inline-flex items-center gap-2 rounded-pill border border-cyan/35 bg-cyan/10 px-4 py-1.5 text-xs font-black uppercase text-teal">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan" />
            Public corporation record · {COMPANY_REGION}
          </span>
          <h1 className="mt-7 max-w-3xl text-5xl font-black leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-7xl">
            {COMPANY_NAME}
          </h1>
          <p className="mt-7 max-w-xl text-lg leading-8 text-muted">
            A clean web profile for {COMPANY_SHORT}, built from its California
            Articles of Incorporation and anchored in {COMPANY_LOCATION}.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#record"
              className="rounded-pill bg-ink px-7 py-3.5 font-semibold text-paper shadow-soft transition hover:bg-teal"
            >
              Review record
            </a>
            <a
              href="#address"
              className="rounded-pill border border-ink/15 bg-white px-7 py-3.5 font-semibold text-ink transition hover:border-cyan hover:bg-steel"
            >
              See location
            </a>
          </div>
        </div>

        <div className="relative min-h-[520px] overflow-hidden rounded-[2rem] bg-ink shadow-soft">
          <img
            src={HERO_IMAGE_URL}
            alt="Modern office interior representing RevoFrame Inc"
            className="absolute inset-0 h-full w-full object-cover opacity-55"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/55 to-transparent" />
          <div className="relative flex h-full min-h-[520px] flex-col justify-end p-6 sm:p-8">
            <div className="grid gap-3 sm:grid-cols-2">
              {PROFILE_FACTS.map((fact) => (
                <div
                  key={fact.label}
                  className="border border-white/12 bg-white/10 px-5 py-5 text-paper backdrop-blur"
                >
                  <p className="text-[11px] font-black uppercase text-cyan">
                    {fact.label}
                  </p>
                  <p className="mt-2 text-2xl font-black leading-tight">{fact.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
